exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".printer__details {\n  display: flex;\n  flex-direction: column;\n  min-width: 471px;\n  text-align: center;\n  background: #f6f6f6;\n  border-radius: 11px;\n  margin-top: 25px;\n  margin-bottom: 33px;\n  padding: 30px 35px; }\n  .printer__details a {\n    color: #000;\n    text-decoration: underline; }\n    .printer__details a:hover {\n      text-decoration: none !important; }\n\n.printer__name {\n  margin-top: 0px !important;\n  max-width: 100vw; }\n\n.dialog__add__printer {\n  padding: 50px; }\n  .dialog__add__printer__title {\n    padding-bottom: 12px !important; }\n\n.centered__dialog__content__text {\n  margin: 0 auto !important; }\n\n.step__descriptor {\n  font-family: Geomanist;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 13px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #797979;\n  margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Dashboard/Panels/Settings/AddPrinterDialog/index.scss
// module id = 6505
// module chunks = 1